import { getUserDataFromStorage } from 'core/auth/auth-provider-config';
import { useMemo } from 'react';

export const useSessionUser = () => {
  const sessionToken = useMemo(() => getUserDataFromStorage(), []);

  const userName: string = useMemo(() => sessionToken.profile.given_name, [sessionToken]);
  const userLastname: string = useMemo(() => sessionToken.profile.family_name, [sessionToken]);
  const userNavifyId: string = useMemo(() => sessionToken.profile.sub, [sessionToken]);

  const formattedUserName: string = useMemo(
    () => `${userName} ${userLastname}`,
    [userName, userLastname]
  );

  const userNameInitials: string = useMemo(
    () => `${userName.charAt(0)}${userLastname.charAt(0)}`.toUpperCase(),
    [userName, userLastname]
  );

  return {
    userNavifyId,
    userName,
    userLastname,
    formattedUserName,
    userNameInitials,
  };
};
